import { useState, useMemo } from "react"
import { Timetable } from "./timetable"
import { getTimetable } from "../api/api"
import { Oval } from "react-loader-spinner"
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"
import "react-datepicker/dist/react-datepicker.css"
import { CustomDateInput } from "./customDateInput"

registerLocale('ru', ru)

export const Trainer = ({ trainer, type, initialDate }) => {
    const today = new Date()
    let maxDate = new Date()

    maxDate.setMonth(maxDate.getMonth() + 1)

    const formatDateForApi = (date) => {
        let dd = date.getDate();
        if (dd < 10) dd = '0' + dd;

        let mm = date.getMonth() + 1;
        if (mm < 10) mm = '0' + mm;

        let yy = date.getFullYear();

        return dd + '.' + mm + '.' + yy;
    }

    const [selectedDate, setSelectedDate] = useState(initialDate || today)

    const [schedule, setSchedule] = useState(trainer.timetable?.filter(el => el.kindOfSport.includes(type)))
    const [loading, setLoading] = useState(true)

    const availableDatesMap = useMemo(() => {
        const dateMap = {}
        if (trainer.calendar && Array.isArray(trainer.calendar)) {
            trainer.calendar.forEach(item => {
                const d = new Date(item.availableDate || item.date)
                const key = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`
                dateMap[key] = item.availableLessonsCount || item.lessonsCount || item.count || 0
            })
        }
        return dateMap
    }, [trainer.calendar])

    const handleDateChange = async (date) => {
        setSchedule([])
        setLoading(false)
        setSelectedDate(date)
        const formattedDate = formatDateForApi(date)
        const data = await getTimetable(trainer.trainer_ID, formattedDate)
        if (data.timetable) setSchedule(data.timetable?.filter(el => el.kindOfSport.includes(type)))
        setLoading(true)
    }

    const renderDayContents = (day, date) => {
        const key = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`
        const lessonsCount = availableDatesMap[key]

        const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        const isPastDate = date < todayStart

        return (
            <div className="day-content">
                <span>{day}</span>
                {lessonsCount && !isPastDate && (
                    <span className="lessons-badge">
                        {lessonsCount}
                    </span>
                )}
            </div>
        )
    }

    const getDayClassName = (date) => {
        const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        if (date < todayStart) {
            return ''
        }
        const key = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`
        if (availableDatesMap[key]) {
            return 'available-day'
        }
        return ''
    }

    const isDateAvailable = (date) => {
        const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        if (date < todayStart) {
            return false
        }
        const key = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`
        return !!availableDatesMap[key]
    }

    return (
        <div className='col-md-4'>
            <div className='icon'>
                <img
                    src={`https://instructors.yes35.ru/img${trainer?.trainer_Photo}`}
                    className='img-responsive'
                    alt={trainer.trainer_FIO}
                />
            </div>
            <div className='service-desc'>
                <h3>{trainer.trainer_FIO}</h3>
                <p dangerouslySetInnerHTML={{ __html: trainer?.description }}></p>
                <div>
                    <p style={{ color: 'black', marginBottom: '8px' }}>Выберите дату:</p>
                    <div className="trainer-calendar">
                        <DatePicker
                            selected={selectedDate}
                            onChange={handleDateChange}
                            minDate={today}
                            maxDate={maxDate}
                            locale="ru"
                            renderDayContents={renderDayContents}
                            dayClassName={getDayClassName}
                            filterDate={isDateAvailable}
                            shouldCloseOnSelect={true}
                            customInput={<CustomDateInput />}
                            dateFormat="d MMMM yyyy"
                            calendarStartDay={1}
                            popperPlacement="bottom-start"
                        />
                    </div>
                </div>
                {
                    loading ?
                        <>
                            {
                                schedule.length > 0 ?
                                    <Timetable schedule={schedule} />
                                    :
                                    <p style={{ color: 'black' }}>На сегодня нет записи</p>
                            }
                        </>
                        :
                        <Oval
                            visible={true}
                            height="80"
                            width="80"
                            color="#ff7f00"
                            secondaryColor='#ff7f00'
                            ariaLabel="loading"
                        />
                }
            </div>
        </div>
    )
}
